module.exports = __webpack_public_path__ + "img/upload-2nd-2.373be961.png";